import { render, staticRenderFns } from "./EditPrice.vue?vue&type=template&id=7258bfb1&"
import script from "./EditPrice.vue?vue&type=script&lang=js&"
export * from "./EditPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7258bfb1')) {
      api.createRecord('7258bfb1', component.options)
    } else {
      api.reload('7258bfb1', component.options)
    }
    module.hot.accept("./EditPrice.vue?vue&type=template&id=7258bfb1&", function () {
      api.rerender('7258bfb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Editbox/EditPrice.vue"
export default component.exports